export const formatCurrency = (value: number, decimals: number = 2) => {
  if (isNaN(value)) return "";

  return (value / 1000).toFixed(decimals);
};
